import React from 'react';
import '../scss/footer.scss'



function Footer(props) {
    return (
        <footer>
        <h1>京ICP备12443567号 © 1997-2020 北京博睿共兴商贸有限公司版权所有</h1>
        </footer>
    )
}


export default Footer